import { Twin } from 'api/model'
import { atom } from 'recoil'

const twinsAtom = atom<Twin[]>({
  key: 'twins',
  default: [],
})

export { twinsAtom }
